/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import type { DivProps } from 'typings';
import { UDText } from 'ud-ui/components';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { UDTable } from 'ud-ui/components/table';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import * as S from './styles';

interface IProps extends DivProps {}

function ComponentPage(props: IProps) {
  const { ...rest } = props;
  const { setHeaderContent } = useMainLayout();
  const params = useParams();
  const { componentName } = params;

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Компонент - {componentName ?? '???'}</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [componentName, setHeaderContent]);

  if (!componentName) return null;

  switch (componentName) {
    case 'table': {
      const items = [
        {
          name: 'Тестовая запись 1',
          date: '2023-07-01',
        },
        {
          name: 'Тестовая запись 2',
          date: '2026-07-01',
        },
        {
          name: 'Тестовая запись 3',
          date: '2027-07-01',
        },
        {
          name: 'Тестовая запись 4',
          date: '2028-07-01',
        },
      ];

      return (
        <S.MainBlock {...rest}>
          <S.Block>
            <UDText as="h2" variant={'title-4'}>
              Пустая таблица
            </UDText>
            <UDTable />
          </S.Block>

          <S.Block>
            <UDText as="h2" variant={'title-4'}>
              Таблица без данных
            </UDText>
            <UDTable>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody></tbody>
            </UDTable>
          </S.Block>

          <S.Block>
            <UDText as="h2" variant={'title-4'}>
              Таблица c isLoading
            </UDText>
            <UDTable isLoading>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody></tbody>
            </UDTable>
          </S.Block>

          <S.Block>
            <UDText as="h2" variant={'title-4'}>
              Таблица с данными
            </UDText>
            <UDTable>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Дата</th>
                  <th>Дата 2</th>
                  <th>Дата 3</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.date}</td>
                    <td>{item.date}</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </UDTable>
          </S.Block>
        </S.MainBlock>
      );
    }
    default:
      return null;
  }
}

export default ComponentPage;
